import { Content, Main } from '@atlaskit/page-layout';
import React, { PropsWithChildren } from 'react';

export function DefaultLayout({ children }: PropsWithChildren<NonNullable<unknown>>) {
  return (
    <Content>
      <Main>{children}</Main>
    </Content>
  );
}
